import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useSuspensionCheck = () => {
  const { user } = useAuth();
  const [isSuspended, setIsSuspended] = useState(false);

  useEffect(() => {
    if (user?.subscription_status === 'suspended') {
      setIsSuspended(true);
    } else {
      setIsSuspended(false);
    }
  }, [user?.subscription_status]);

  return {
    isSuspended,
    suspensionStatus: user?.subscription_status || 'trial'
  };
};